import { Button } from 'components/universal/button';
import Heading from 'components/universal/heading';
import { Input } from 'components/universal/input';
import Paragraph from 'components/universal/paragraph';
import cls from './registration.module.scss';
import { useProfilUpdate } from './useProfilUpdate';
import { Controller } from 'react-hook-form';
import { AsyncPaginate } from 'react-select-async-paginate';
import { DropdownIndicator } from 'components/universal/addMultipleUser';

export interface UpdateUserRequest {
    first_name: string;
    last_name: string;
    phone?: string;
    workplace_name: string;
    workplace_address_city: string;
    workplace_address_street: string;
    workplace_address_number: string;
    workplace_address_postcode: string;
    employee_position_name?: string;
    department?: string;
    department_id?: number;
}

export const ProfileUpdate = () => {
    const {
        registerUpdate,
        handleSubmitUpdate,
        setErrorUpdate,
        onSubmitUpdate,
        updateErrors,
        t,
        control,
        setValueUpdate,
        selectedDepartment,
        loadDepartmentOptions,
        handleDepartmentChange,
    } = useProfilUpdate();
    
    return (
        <div className={cls.containerChange}>
            <Heading
                className={cls.headingChange}
                headingLevel="h1"
                headingStyle="h2"
            >
                {t('passwordUpdate.title')}
            </Heading>
            <Paragraph
                className={cls.descriptionChange}
            >
                {t('registration.descriptionProfile')}
            </Paragraph>
            <form className={cls.formProfile} onSubmit={handleSubmitUpdate(onSubmitUpdate)}>
                <Input
                    className={`${cls.inputHalfWidth}`}
                    register={registerUpdate}
                    id="first_name"
                    name="first_name"
                    label={t('registration.firstNameRequire')}
                    error={t(updateErrors.first_name?.message)}
                    maxLength={255}
                />
                <Input
                    className={`${cls.inputHalfWidth}`}
                    register={registerUpdate}
                    id="last_name"
                    name="last_name"
                    label={t('registration.lastNameRequire')}
                    error={t(updateErrors.last_name?.message)}
                    maxLength={255}
                />
                <Input
                    className={`${cls.input} ${cls.full}`}
                    register={registerUpdate}
                    id="employee_position_name"
                    name="employee_position_name"
                    label={t('registration.position')}
                    error={t(updateErrors.employee_position_name?.message)}
                    maxLength={255}
                />
                <Input
                    className={`${cls.inputHalfWidth}`}
                    register={registerUpdate}
                    id="workplace_name"
                    name="workplace_name"
                    label={t('registration.workplaceName')}
                    error={t(updateErrors.workplace_name?.message)}
                    maxLength={255}
                    disabled={true}
                />
                <div className={cls.select}>
                    <label htmlFor="department_id" className={cls.label}>
                        {t('registration.department')}
                    </label>
                    <Controller
                        name="department_id"
                        control={control}
                        render={() => (
                            <AsyncPaginate
                                className={updateErrors.department_id ? 'error react-select-container' : 'react-select-container'}
                                classNamePrefix="react-select"
                                components={{ DropdownIndicator }}
                                placeholder=""
                                value={selectedDepartment}
                                loadOptions={loadDepartmentOptions}
                                defaultOptions
                                additional={{ page: 1 }}
                                onChange={handleDepartmentChange}
                                noOptionsMessage={() => t('registration.noDepartments')}
                                debounceTimeout={300}
                            />
                        )}
                    />
                    {updateErrors.department_id && (
                        <span className={cls.errorBox}>{t(updateErrors.department_id.message).replace('department id', t('registration.firstLoginModal.department').toLowerCase())}</span>
                    )}
                </div>
                <input type="hidden" {...registerUpdate('email')} />
                <input type="hidden" {...registerUpdate('workplace_id')} />
                <input type="hidden" {...registerUpdate('department_id')} />
                <input type="hidden" {...registerUpdate('workplace_address_city')} />
                <input type="hidden" {...registerUpdate('workplace_address_street')} />
                <input type="hidden" {...registerUpdate('workplace_address_number')} />
                <input type="hidden" {...registerUpdate('workplace_address_postcode')} />
                <div className={cls.buttonProfileForm}>
                    <Button className={`${cls.buttonType2} mx-auto mb-4`} type="submit">
                        {t('passwordUpdate.button')}
                    </Button>
                </div>
            </form>
        </div>
    )
};